module.exports = __webpack_public_path__ + "img/dashboard-icon.6ae27fe0.svg";